import { withStyles } from 'vopay';
import styles from './WeekdayToggleGroup.module.scss';

const cn = withStyles(styles);

export type WeekdayCode = 'SU' | 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA';

const WEEKDAYS: { code: WeekdayCode; label: string }[] = [
  { code: 'SU', label: 'S' },
  { code: 'MO', label: 'M' },
  { code: 'TU', label: 'T' },
  { code: 'WE', label: 'W' },
  { code: 'TH', label: 'T' },
  { code: 'FR', label: 'F' },
  { code: 'SA', label: 'S' },
];

export type WeekdayToggleGroupProps = {
  value: WeekdayCode[];
  onChange: (value: WeekdayCode[]) => void;
  disabled?: boolean;
};

export default function WeekdayToggleGroup({ value, onChange, disabled }: WeekdayToggleGroupProps) {
  function toggle(code: WeekdayCode) {
    if (disabled) return;
    onChange(value.includes(code) ? value.filter((v) => v !== code) : [...value, code]);
  }

  return (
    <div className={cn('group')}>
      {WEEKDAYS.map(({ code, label }) => {
        const selected = value.includes(code);
        return (
          <button
            key={code}
            type="button"
            aria-pressed={selected}
            aria-label={code}
            disabled={disabled}
            className={cn('pill', selected && 'selected')}
            onClick={() => toggle(code)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
